<template>
    <!-- topData.date: {{ props.topData }}<br /> -->
    <div class="boxRounded today" v-if="props.topData">
        <template v-for="(e, i) in props.topData.todayLearningList" :key="i">
            <!-- <template v-for="(b, i) in e.study_list" :key="i"> -->
            <StudyItemNormal :isTop="true" :one="e" />
            <!-- </template> -->
        </template>
    </div>
    <!-- props.studyData:   {{ props.studyData }} -->

    <div v-if="props.studyData?.type === 'EVENT'" class="redBox event">
        <template v-for="(e, i) in props.studyData?.list" :key="i">
            <StudyItemEvent :date="props.studyData.date" :one="e" />
        </template>
    </div>
    <!-- <div v-if="props.studyData?.type === 'NORMAL' || props.studyData?.type === 'DIAGNOSTIC' || props.studyData?.type === 'SAT'" class="boxRounded" v-for="(e, i) in props.studyData?.list" :key="i"> -->

    <div v-if="props.studyData?.type === 'NORMAL'" class="boxRounded normal">
        <!-- <div class="normalBox" v-if="props.studyData.type === 'NORMAL'"> -->
        <template v-for="(e, i) in props.studyData?.list" :key="i">
            <StudyItemNormal2 :isTop="false" :one="e" />
        </template>
        <!-- </div> -->
    </div>
    <div v-if="props.studyData?.type === 'DIAGNOSTIC' || props.studyData?.type === 'SAT' || props.studyData?.type === 'SAT_RESET'" class="boxRounded diagnostic">
        <!-- <div class="normalBox" v-if="props.studyData.type === 'DIAGNOSTIC' || props.studyData.type === 'SAT'"> -->
        <template v-for="(e, i) in props.studyData?.list" :key="i">
            <StudyItemDiagnostic :type="props.studyData.type" :one="e" />
        </template>
        <!-- </div> -->
    </div>

    <!-- <template v-for="(e, i) in props.studyData.list" :key="i">
        <div class="normalBox" v-if="props.studyData.type === 'NORMAL'">
            <StudyItemNormal :one="e" />
        </div>
        <div class="normalBox" v-if="props.studyData.type === 'DIAGNOSTIC' || props.studyData.type === 'SAT'">
            <StudyItemDiagnostic :type="props.studyData.type" :one="e" />
        </div>
        <div class="redBox" v-if="props.studyData.type === 'EVENT'"> -->
    <!-- <StudyItemEvent :date="props.studyData.date" :one="e" />
        </div> -->
    <!-- </template> -->
</template>

<script setup>
import { onMounted, ref, defineProps } from 'vue';
import StudyItemNormal from '@/views/userMap/components/studyItemNormal.vue';
import StudyItemNormal2 from '@/views/userMap/components/studyItemNormal2.vue';
import StudyItemDiagnostic from '@/views/userMap/components/studyItemDiagnostic.vue';
import StudyItemEvent from '@/views/userMap/components/studyItemEvent.vue';

const props = defineProps({
    // 오늘학습용
    topData: {
        Type: Object,
    },
    // 학습기록용
    studyData: {
        Type: Object,
    },
});

onMounted(() => {
    // console.log('--box--aa:', props.studyData);
});
////////////////////////////----OnClick----////////////////////////////
</script>

<style scoped lang="scss">
// .normalBox {
//     margin: 20px;
//     padding: 20px;
//     border: 1px solid #e0e0e0;
//     border-radius: 10px;
//     background-color: white;
// }
.redBox {
    // margin: 20px 20px 120px 20px;
    margin: 20px;
    padding: 40px 20px;
    border: 1px solid #ef2b2a;
    border-radius: 10px;
    background-color: #ef2b2a11;
}

.boxRounded {
    @include border-radius(1.33vmin);
    &.today {
        padding: 5.34vmin 6.67vmin 5.34vmin;
    }
    &.event {
        padding: 4vmin 3.33vmin;
    }
    &.normal {
        padding: 3.33vmin;
    }

    &.diagnostic {
        padding: 3.33vmin;
    }
}
</style>
